import {
  route,
  loadingAsyncState,
} from 'widgets-for-react'
import { CustomRouteParams } from '../../cms/router/type.gen'
import { PublicSiteCustomRoutes, CustomPagesState, CustomPage } from './types.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { searchResults } from '../../searchResults'
import { WordPress } from '../../wordpress/wordpress_api'
import { AxiosResponse } from 'axios'
import { PaginationResponse } from '../../wordpress/types_and_parser/extra_types.mod'



export const search: CustomPage<CustomPagesState['search']> = {
  widget: searchResults,
  route: route<{ term: string }, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>(
    '/:lang?/(zoeken|search)/:term*',
    s => ({ kind: 'search', term: s.term || ''})
  ),
  getState: (s: PublicSiteState) => ({ ...s.search, header: s.header }),
  setState: (s: PublicSiteState, ss: CustomPagesState['search']) => ({
    ...s,
    search: ss,
    header: ss.header
  }),
  updateStateBasesOnRoute: (s, r) => {
    const searchParams: URLSearchParams = new URL(location.href).searchParams
    return r.kind != 'search'
      ? s
      : {
          ...s,
          header: {
            ...s.header,
            searchValue: r.term
          },
          search: {
            header: s.header,
            request: loadingAsyncState(async () => {
              let result: AxiosResponse<PaginationResponse<WordPress.PostTypeResponse[]>> = {} as AxiosResponse<PaginationResponse<WordPress.PostTypeResponse[]>>
              if (r.term) {
                result = await WordPress.api().search(r.term, searchParams.has('page') ? parseInt(searchParams.get('page')) : 1)
                if (result.statusText == 'OK' || result.statusText == 'No Content') 
                  window.dataLayer.push({
                    event: "event", category: "Search", action: result.statusText, label: r.term
                  });
              }
              return { kind: 'result', status: 200, value: result }
            }),
            response: null,
            pager: { 
              ...s.search.pager, 
              current_page: searchParams.has('page') ? parseInt(searchParams.get('page')) : 1,
              items_per_page: 10
            }
          }
        }
  }
}
